import { AppPermissionMasterRaw } from "@/domain/AppPermissionMaster";
import { API_CLIENT } from "../config";
import { getAPIConfigs } from "../helpers";

const apiUrlPermissionMasters = "/app_permission_masters";

export const getAppPermissionMasters = async ({
  organizationId,
}: {
  organizationId?: string;
}): Promise<AppPermissionMasterRaw[]> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.get<{ items: AppPermissionMasterRaw[] }>(
    apiUrlPermissionMasters,
    {
      ...apiOrganizationIdParams,
    }
  );
  return response.data.items;
};
